import type { File, Folder } from '@/types/folders/folder';
import type { OrganizationMember } from './me';

/**
 * Normalizers for response shapes the API does not keep consistent.
 * Components receive the normalized form only.
 */

/**
 * A message's `document_ids` arrives either as an array or as an object
 * whose values are the ids (a PHP array with non-sequential keys). Empty
 * entries are dropped.
 */
export const normalizeDocumentIds = (documentIds: unknown): string[] => {
  if (Array.isArray(documentIds)) {
    return documentIds.filter(Boolean);
  }
  if (documentIds && typeof documentIds === 'object') {
    return Object.values(documentIds).filter(Boolean) as string[];
  }
  return [];
};

/**
 * POST /organization/members/ids answers with a bare array or with the
 * usual `{ success, data }` envelope.
 */
export const normalizeMemberList = (
  response: unknown,
): OrganizationMember[] => {
  if (Array.isArray(response)) {
    return response;
  }
  const data = (response as { data?: unknown } | null | undefined)?.data;
  return Array.isArray(data) ? data : [];
};

export interface FolderListing {
  folders: Folder[];
  files: File[];
}

/** GET /folder: a failed request or a missing key means an empty listing. */
export const normalizeFolderListing = (response: {
  data?: Partial<FolderListing> | null;
}): FolderListing => {
  const { folders = [], files = [] } = response.data || {};
  return { folders, files };
};
